import { render } from "./UpdateSale.vue?vue&type=template&id=ed767c50"
import script from "./UpdateSale.vue?vue&type=script&lang=js"
export * from "./UpdateSale.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__